export default __webpack_public_path__ + "static/media/14_photo.7da0a6f7.jpeg";